import React, { useState } from 'react';

import { Modal, PrimaryButton } from '../../components';
import { formatMoney } from '../../util/currency';
import { apiBaseUrl } from '../../util/api';

import css from './MakeOfferModal.module.css';

const MakeOfferModal = ({ listing, isOpen, onClose, onSuccess, onManageDisableScrolling, intl }) => {
  const [amount, setAmount] = useState('');
  const [error, setError] = useState(null);
  const [submitting, setSubmitting] = useState(false);
  const askingPrice = listing?.attributes?.price;
  const minimumOfferAmount = listing?.attributes?.publicData?.minimumOfferAmount;

  const submit = event => {
    event.preventDefault();
    const numericAmount = Number(amount);
    const subunits = Math.round(numericAmount * 100);
    if (!/^\d+(\.\d{1,2})?$/.test(amount) || subunits <= 0) {
      setError('Enter a valid offer amount with no more than two decimal places.');
      return;
    }
    if (subunits >= askingPrice.amount) {
      setError(`This item is available to buy now for ${formatMoney(intl, askingPrice)}.`);
      return;
    }
    if (minimumOfferAmount && subunits < minimumOfferAmount) {
      setError(`This seller is accepting offers of $${(minimumOfferAmount / 100).toFixed(2)} or more.`);
      return;
    }
    setSubmitting(true);
    setError(null);
    fetch(`${apiBaseUrl()}/api/offers`, {
      method: 'POST',
      credentials: 'include',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ listingId: listing.id.uuid, offerPriceSubunits: subunits }),
    })
      .then(async response => {
        const data = await response.json();
        if (!response.ok) throw new Error(data.error || 'Unable to send offer.');
        return data.offer;
      })
      .then(offer => {
        setAmount('');
        onSuccess(offer);
        onClose();
      })
      .catch(requestError => setError(requestError.message))
      .finally(() => setSubmitting(false));
  };

  return (
    <Modal id="MakeOfferModal" isOpen={isOpen} onClose={onClose} onManageDisableScrolling={onManageDisableScrolling}>
      <div className={css.root}>
        <h2 className={css.title}>Make an offer</h2>
        <p className={css.description}>
          The seller is asking {askingPrice ? formatMoney(intl, askingPrice) : ''}. Enter the price you'd like to offer.
        </p>
        <form onSubmit={submit}>
          <label className={css.label} htmlFor="offerAmount">Offer amount (CAD)</label>
          <input id="offerAmount" className={css.input} inputMode="decimal" value={amount} onChange={event => { setAmount(event.target.value); setError(null); }} />
          {error ? <p className={css.error}>{error}</p> : null}
          <div className={css.actions}>
            <button className={css.cancel} type="button" onClick={onClose}>Cancel</button>
            <PrimaryButton type="submit" inProgress={submitting} disabled={submitting}>Submit offer</PrimaryButton>
          </div>
        </form>
      </div>
    </Modal>
  );
};

export default MakeOfferModal;
